export const rakValuesList = [
  {
    optionList: [
      {
        text: "One stop business solution <strong>Basic</strong>",
        items: ["Connected banking experience", "Automated accounting", "Integrated VAT solution"]
      },
      {
        text: "Business insurance <strong>Basic</strong>",
        textIslamic: "Business Takaful <strong>Basic</strong>"
      },
      { text: "Host of other banking and lifestyle benefits" }
    ],
    isIncluded: true,
    cost: 51.45,
    value: "RAKvalue SME PLUS",
    buttonLabel: "Selected",
    notSelectedLabel: "Select",
    disabledLabelForForeignCurrency: "Not Applicable",
    _id: "RAKvalue PLUS"
  },
  {
    optionList: [
      {
        text: "One stop business solution <strong>Advanced</strong>",
        items: ["Connected banking experience", "Automated accounting", "Integrated VAT solution"]
      },
      {
        text: "Business insurance <strong>Advanced</strong>",
        textIslamic: "Business Takaful <strong>Advanced</strong>"
      },
      { text: "Host of other banking and lifestyle benefits" }
    ],
    isIncluded: false,
    cost: 156.45,
    value: "RAKvalue SME MAX",
    buttonLabel: "Selected",
    notSelectedLabel: "Select",
    disabledLabelForForeignCurrency: "Not Applicable",
    _id: "RAKvalue MAX"
  }
];
